"use client";

import Image from "next/image";
import React from "react";
import { Button } from "@/components/ui/button";
import { stepsArray } from "@/constants/Constants";
import { useRouter } from "next/navigation";
import { useSelector } from "react-redux";
import { useGetUserAnalyticsQuery } from "@/state/api";
import { RightLoading } from "@/components/admin/right-screen-loading/page";
import OldDashboard from "@/components/admin/olddashboard-component/OldDashboard";

const DashboardPage = () => {
  const router = useRouter();

  const personName = useSelector((state: any) => state.global.user);
  const name =
    personName.role === "user"
      ? personName?.aboutYou?.name
      : personName?.aboutCompany?.name;
  const id = personName?.id;
  const { data, isError, isLoading, refetch } = useGetUserAnalyticsQuery(
    { userId: id },
    { skip: !id }
  );
  const userAnalytics = data?.data;
  const totalCount = data?.meta?.totalCount;

  if (isLoading) {
    return <RightLoading />;
  } else if (isError) {
    return <div>Error loading data</div>;
  } else {
    return (
      <div className="min-h-screen">
        <div className="flex min-w-full flex-1 mx-auto bg-back">
          <section className="flex items-center justify-center  w-full relative">
            <div className="max-sm:mt-20 md:mt-20 flex flex-col flex-start sm:flex-center">
              <div className="flex flex-col items-center ">
                <Image src="/logo.png" height={50} width={53} alt="Logo" />{" "}
                <h1 className="h1-medium text-blue-200 mb-8 mt-10 text-center text-[48px] max-w-[700px] w-full mx-auto break-words whitespace-normal">
                  Hello{" "}
                  {name ? name.charAt(0).toUpperCase() + name.slice(1) : ""}!
                </h1>
              </div>
              <h1 className="text-center h1-medium text-black-200 mb-8 px-10">
                Time to deliver your sales pitch!
              </h1>
              {totalCount === 0 && (
                <div className="flex-center flex flex-wrap gap-8 w-full mb-20">
                  {stepsArray.map(
                    (item: { step: string; text: string }, index: number) => (
                      <div
                        key={index}
                        className="w-[230px] h-[120px] rounded-2xl bg-white border-1 border-blue-100 flex flex-col justify-center gap-3 pt-2 px-[16px]"
                      >
                        <p className="text-grey-200 paragraph-regular">
                          {item.step}
                        </p>
                        <p className="h3-semibold">{item.text}</p>
                      </div>
                    )
                  )}
                </div>
              )}

              <Button
                className=" bg-blue-200 rounded-full md:min-w-[400px] max-md:w-[230px] min-h-[54px]"
                onClick={() => router.push("/seller-industry")}
              >
                Start New Pitch
              </Button>
            </div>
          </section>
        </div>
        {totalCount > 0 && (
          <div className="w-full sm:w-full md:w-[800px] lg:w-[840px] flex m-auto flex-col gap-5 p-10">
            <OldDashboard data={data} pageUrl="member-profile-page" />
          </div>
        )}
      </div>
    );
  }
};

export default DashboardPage;
